<template>
    <div>
        <v-dialog v-model="show" max-width="800px" persistent>
            <v-card>
                <v-card-title class="primary white--text">
                    <v-icon left color="white">mdi-cog</v-icon>
                    Envio automático de relatório de repasse e taxas
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="fecharModal">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-6">
                    <Loading :active="loading" :is-full-page="false" />

                    <v-row>
                        <v-col cols="12">
                            <v-card outlined class="mb-4">
                                <v-card-title class="subtitle-1 primary--text">
                                    <v-icon left color="primary"
                                        >mdi-toggle-switch</v-icon
                                    >
                                    CONFIGURAÇÃO GERAL
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-switch
                                                v-model="
                                                    dadosEnvio.envioAutomaticoAtivo
                                                "
                                                label="Ativar envio automático"
                                                color="primary"
                                                hide-details
                                                class="ma-0"
                                            ></v-switch>
                                            <div
                                                class="text-caption grey--text mt-2"
                                            >
                                                Quando ativado, os relatórios
                                                serão enviados automaticamente
                                                conforme a frequência
                                                configurada
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12">
                            <v-card outlined class="mb-4">
                                <v-card-title class="subtitle-1 info--text">
                                    <v-icon left color="info"
                                        >mdi-email-multiple</v-icon
                                    >
                                    LISTA DE E-MAILS
                                </v-card-title>
                                <v-card-text>
                                    <div
                                        v-for="(email,
                                        index) in dadosEnvio.emails"
                                        :key="index"
                                        class="mb-3"
                                    >
                                        <v-row no-gutters>
                                            <v-col cols="10">
                                                <v-text-field
                                                    v-model="
                                                        dadosEnvio.emails[index]
                                                    "
                                                    :label="
                                                        `E-mail ${index + 1}`
                                                    "
                                                    type="email"
                                                    :disabled="
                                                        !dadosEnvio.envioAutomaticoAtivo
                                                    "
                                                    :rules="emailRules"
                                                    outlined
                                                    dense
                                                    :class="
                                                        dadosEnvio.envioAutomaticoAtivo
                                                            ? 'editable-field'
                                                            : 'readonly-field'
                                                    "
                                                    placeholder="exemplo@empresa.com"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                cols="2"
                                                class="delete-button-container"
                                            >
                                                <v-tooltip top>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                            attrs
                                                        }"
                                                    >
                                                        <v-btn
                                                            icon
                                                            color="error"
                                                            :disabled="
                                                                !dadosEnvio.envioAutomaticoAtivo ||
                                                                    dadosEnvio
                                                                        .emails
                                                                        .length <=
                                                                        1
                                                            "
                                                            @click="
                                                                removerEmail(
                                                                    index
                                                                )
                                                            "
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            <v-icon
                                                                >mdi-delete</v-icon
                                                            >
                                                        </v-btn>
                                                    </template>
                                                    <span>Remover e-mail</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <v-row>
                                        <v-col cols="12">
                                            <v-btn
                                                color="primary"
                                                outlined
                                                small
                                                :disabled="
                                                    !dadosEnvio.envioAutomaticoAtivo
                                                "
                                                @click="adicionarEmail()"
                                            >
                                                <v-icon small class="mr-2"
                                                    >mdi-plus</v-icon
                                                >
                                                Adicionar contato
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12">
                            <v-card outlined>
                                <v-card-title class="subtitle-1 success--text">
                                    <v-icon left color="success"
                                        >mdi-calendar-clock</v-icon
                                    >
                                    FREQUÊNCIA DE ENVIO
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-radio-group
                                                v-model="
                                                    dadosEnvio.frequenciaEnvio
                                                "
                                                :disabled="
                                                    !dadosEnvio.envioAutomaticoAtivo
                                                "
                                                row
                                                class="ma-0"
                                            >
                                                <v-radio
                                                    label="Diário"
                                                    value="diario"
                                                    color="primary"
                                                    class="mr-6"
                                                ></v-radio>
                                                <v-radio
                                                    label="Semanal"
                                                    value="semanal"
                                                    color="primary"
                                                    class="mr-6"
                                                ></v-radio>
                                                <v-radio
                                                    label="Quinzenal"
                                                    value="quinzenal"
                                                    color="primary"
                                                    class="mr-6"
                                                ></v-radio>
                                                <v-radio
                                                    label="Mensal"
                                                    value="mensal"
                                                    color="primary"
                                                ></v-radio>
                                            </v-radio-group>
                                            <div
                                                class="text-caption grey--text mt-2"
                                            >
                                                Selecione com que frequência
                                                deseja receber os relatórios
                                                automaticamente
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="pa-6">
                    <v-btn
                        color="success"
                        @click="salvarDados"
                        :loading="loading"
                        :disabled="!validarForm() || loading"
                    >
                        <v-icon left>mdi-content-save</v-icon>
                        Salvar dados
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="grey"
                        text
                        @click="cancelarEdicao"
                        :disabled="loading"
                    >
                        Cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import ConfiguracaoRepasseService from '@/services/ConfiguracaoRepasseService';
import Vue from 'vue';

export default {
    name: 'ModalGerenciarEnvio',
    components: {
        Loading
    },
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        dadosIniciais: {
            type: Object,
            default: () => ({
                envioAutomaticoAtivo: false,
                emails: [''],
                frequenciaEnvio: 'semanal'
            })
        }
    },
    data() {
        return {
            loading: false,
            configuracaoRepasseService: new ConfiguracaoRepasseService(
                Vue.http,
                this.$store
            ),
            dadosEnvio: {
                envioAutomaticoAtivo: false,
                emails: [''],
                frequenciaEnvio: 'semanal'
            },
            emailRules: [
                v => {
                    if (!this.dadosEnvio.envioAutomaticoAtivo) return true;
                    return !!v || 'E-mail é obrigatório';
                },
                v => {
                    if (!this.dadosEnvio.envioAutomaticoAtivo || !v)
                        return true;
                    return /.+@.+\..+/.test(v) || 'E-mail deve ser válido';
                }
            ]
        };
    },
    computed: {
        show: {
            get() {
                return this.showModal;
            },
            set(value) {
                if (!value) {
                    this.$emit('fecharModal');
                }
            }
        }
    },
    watch: {
        showModal: {
            immediate: true,
            handler(novoValor) {
                if (novoValor) {
                    this.carregarConfiguracoes();
                }
            }
        },
        dadosIniciais: {
            immediate: true,
            deep: true,
            handler(novoValor) {
                if (novoValor && this.showModal) {
                    this.carregarConfiguracoes();
                }
            }
        }
    },
    methods: {
        async carregarConfiguracoes() {
            try {
                this.loading = true;

                const response = await this.configuracaoRepasseService.buscarConfiguracoes();

                const configuracoes = response?.configuracao || response;

                this.dadosEnvio = {
                    envioAutomaticoAtivo:
                        configuracoes?.envio_automatico_ativo || false,
                    emails:
                        configuracoes?.emails && configuracoes.emails.length > 0
                            ? [...configuracoes.emails]
                            : [''],
                    frequenciaEnvio:
                        configuracoes?.frequencia_envio || 'semanal'
                };
            } catch (error) {
                console.error('Erro ao carregar configurações:', error);

                this.inicializarDados();

                this.$emit(
                    'mostrarMensagem',
                    'mdi-alert',
                    'warning',
                    'Erro ao carregar configurações.'
                );
            } finally {
                this.loading = false;
            }
        },

        inicializarDados() {
            this.dadosEnvio = {
                envioAutomaticoAtivo:
                    this.dadosIniciais.envioAutomaticoAtivo || false,
                emails:
                    this.dadosIniciais.emails &&
                    this.dadosIniciais.emails.length > 0
                        ? [...this.dadosIniciais.emails]
                        : [''],
                frequenciaEnvio: this.dadosIniciais.frequenciaEnvio || 'semanal'
            };
        },

        adicionarEmail() {
            this.dadosEnvio.emails.push('');
        },

        removerEmail(index) {
            if (this.dadosEnvio.emails.length > 1) {
                this.dadosEnvio.emails.splice(index, 1);
            }
        },

        validarForm() {
            if (!this.dadosEnvio.envioAutomaticoAtivo) {
                return true;
            }

            const emailsValidos = this.dadosEnvio.emails.filter(
                email => email && email.trim() && /.+@.+\..+/.test(email)
            );

            return emailsValidos.length > 0 && this.dadosEnvio.frequenciaEnvio;
        },

        async salvarDados() {
            try {
                this.loading = true;

                const emailsLimpos = this.dadosEnvio.emails.filter(
                    email => email && email.trim()
                );

                const dadosParaSalvar = {
                    envioAutomaticoAtivo: this.dadosEnvio.envioAutomaticoAtivo,
                    emails: emailsLimpos,
                    frequenciaEnvio: this.dadosEnvio.frequenciaEnvio
                };

                await this.configuracaoRepasseService.salvarConfiguracoes(
                    dadosParaSalvar
                );

                this.$emit('salvarDados', dadosParaSalvar);

                this.$emit(
                    'mostrarMensagem',
                    'mdi-check',
                    'success',
                    'Configurações salvas com sucesso!'
                );

                this.fecharModal();
            } catch (error) {
                console.error('Erro ao salvar dados:', error);
                this.$emit(
                    'mostrarMensagem',
                    'mdi-alert',
                    'error',
                    'Erro ao salvar configurações'
                );
            } finally {
                this.loading = false;
            }
        },

        cancelarEdicao() {
            this.carregarConfiguracoes();
            this.fecharModal();
        },

        fecharModal() {
            this.$emit('fecharModal');
        }
    }
};
</script>

<style scoped>
.v-card-title {
    font-weight: 600;
}

.v-dialog > .v-card > .v-card-text {
    max-height: 80vh;
    overflow-y: auto;
}

.readonly-field >>> .v-input__control {
    opacity: 0.6;
}

.readonly-field >>> .v-text-field__details {
    opacity: 0.6;
}

.readonly-field >>> input,
.readonly-field >>> textarea {
    color: #666 !important;
    background-color: #f5f5f5 !important;
    cursor: not-allowed !important;
}

.readonly-field >>> .v-input__slot {
    background-color: #f5f5f5 !important;
}

.readonly-field >>> .v-text-field--outlined fieldset {
    border-color: #ddd !important;
}

.readonly-field
    >>> .v-text-field--outlined:not(.v-input--is-focused):not(.v-text-field--filled)
    .v-text-field__slot:hover
    fieldset {
    border-color: #ddd !important;
}

.editable-field >>> .v-text-field--outlined fieldset {
    border-color: #1976d2 !important;
    border-width: 2px !important;
}

.editable-field
    >>> .v-text-field--outlined:not(.v-input--is-focused):not(.v-text-field--filled)
    .v-text-field__slot:hover
    fieldset {
    border-color: #1565c0 !important;
}

.editable-field >>> .v-input__slot {
    background-color: #ffffff !important;
}

.readonly-field >>> .v-label {
    color: #666 !important;
    font-weight: normal !important;
}

.v-radio-group--disabled >>> .v-radio {
    opacity: 0.6;
}

.v-radio-group--disabled >>> .v-input--radio-group__input {
    opacity: 0.6;
}

.delete-button-container {
    display: flex !important;
    justify-content: center !important;
    align-items: flex-start !important;
    padding-top: 6px !important;
    padding-right: 80px !important;
}

.delete-button-container .v-btn {
    margin: 0 !important;
}
</style>
